const filterTracksWithSameMix = (tracks: Track[]): Track[] => {
	const uniqueIds = new Set<number>()
	const uniqueTracks: Track[] = []

	tracks.forEach((track) => {
		if (
			!uniqueIds.has(track.id) &&
			(track.parentId === null || !uniqueIds.has(track.parentId))
		) {
			uniqueTracks.push(track)
			uniqueIds.add(track.id)
			if (track.parentId !== null) {
				uniqueIds.add(track.parentId)
			}
		}
	})

	return uniqueTracks
}

export default filterTracksWithSameMix
